module.exports = __webpack_public_path__ + "img/Restaurant location Icon - charcoal.893ad6be.svg";